import React, { Component } from "react";
import axios from "axios";
import {
  API_INFORMES,
  API_INFORMES_PDF,
  TIPO_INFORME_EVAL_INICIAL,
  RAMA_SENSORIAL,
  pdfEvalInicialScript,
  emptyDatosEvalInicialSensorial,
  normalizarDatosEvalInicialSensorial,
  estadoFirmaEspecialista,
  MSG_FIRMA_PDF_REQUERIDA,
} from "./api";
import FirmaEspecialistaInforme from "./FirmaEspecialistaInforme";
import {
  TIPO_CAMPO,
  CAMPOS_DATOS_GENERALES,
  CAMPOS_ANTECEDENTES,
  CAMPOS_AVD,
  CAMPOS_AVD_INSTRUMENTALES,
  CAMPOS_CONDUCTA,
  CAMPOS_COGNICION_BASE,
  CAMPOS_SENSORIAL_SISTEMAS,
  CAMPOS_SOCIAL,
  CAMPOS_MOTRICIDAD_FINA,
  CAMPOS_MOTRICIDAD_GRUESA,
  CAMPOS_OBSERVACIONES,
  CAMPOS_CIERRE,
} from "./camposEvalInicialSensorial";

class InformeEvaluacionInicialSensorial extends Component {
  constructor(props) {
    super(props);
    this.firmaRef = React.createRef();
    this.state = {
      datos: emptyDatosEvalInicialSensorial(),
      guardando: false,
      tieneFirmaEsp: false,
    };
  }

  componentDidMount() {
    this.cargarDatos();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.idInforme !== this.props.idInforme ||
      prevProps.idasociarE !== this.props.idasociarE ||
      prevProps.initialDatos !== this.props.initialDatos
    ) {
      this.cargarDatos();
    }
  }

  cargarDatos = () => {
    if (this.props.initialDatos && !this.props.idInforme) {
      this.setState({
        datos: normalizarDatosEvalInicialSensorial(this.props.initialDatos),
      });
      return;
    }
    const { idInforme, cedulaPaciente, idasociarE } = this.props;
    if (idInforme > 0) {
      const data = new FormData();
      data.append("boton", "obtener");
      data.append("idInforme", idInforme);
      data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
      axios.post(API_INFORMES, data).then((res) => {
        if (res.data.variable1) {
          this.setState({
            datos: normalizarDatosEvalInicialSensorial(res.data.variable3),
          });
        }
      });
      return;
    }
    const data = new FormData();
    data.append("boton", "datosPacienteBase");
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("idasociarE", idasociarE);
    data.append("tipoInforme", TIPO_INFORME_EVAL_INICIAL);
    data.append("ramaEspecialidad", RAMA_SENSORIAL);
    axios.post(API_INFORMES, data).then((res) => {
      if (res.data.variable1) {
        const base = res.data.variable2;
        this.setState({
          datos: {
            ...emptyDatosEvalInicialSensorial(),
            datosGenerales: {
              ...emptyDatosEvalInicialSensorial().datosGenerales,
              ...base,
            },
          },
        });
      }
    });
  };

  setDg = (field, value) => {
    this.setState({
      datos: {
        ...this.state.datos,
        datosGenerales: { ...this.state.datos.datosGenerales, [field]: value },
      },
    });
  };

  setField = (field, value) => {
    this.setState({ datos: { ...this.state.datos, [field]: value } });
  };

  setNested = (group, field, value) => {
    this.setState({
      datos: {
        ...this.state.datos,
        [group]: { ...this.state.datos[group], [field]: value },
      },
    });
  };

  guardar = () => {
    const {
      cedulaPaciente,
      cedulaEspecialista,
      tipoEvaluacion,
      idasociarE,
      idasociarEGrupo,
      sede,
      idInforme,
      onGuardado,
    } = this.props;
    const { datos } = this.state;
    const dg = datos.datosGenerales;
    this.setState({ guardando: true });
    const data = new FormData();
    data.append("boton", "guardar");
    data.append("tipoInforme", TIPO_INFORME_EVAL_INICIAL);
    data.append("ramaEspecialidad", RAMA_SENSORIAL);
    data.append("idInforme", idInforme || 0);
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("cedulaEspecialista", cedulaEspecialista);
    data.append("tipoEvaluacion", tipoEvaluacion);
    data.append("idasociarE", idasociarE);
    const idsGrupo =
      Array.isArray(idasociarEGrupo) && idasociarEGrupo.length > 0
        ? idasociarEGrupo
        : [idasociarE];
    data.append("idasociarEGrupo", idsGrupo.join(","));
    data.append("formato", "UNICO");
    data.append("fechaInforme", dg.fechaInforme);
    data.append("fechaInicioTerapia", dg.fechaInicioTerapia || "");
    data.append("sede", sede || "");
    data.append("usuario", cedulaEspecialista);
    data.append("datosJson", JSON.stringify(datos));
    axios.post(API_INFORMES, data).then((res) => {
      this.setState({ guardando: false });
      if (res.data.variable1) {
        alert("Fue guardada la Evaluación Inicial");
        if (onGuardado) onGuardado(res.data.variable2);
      } else {
        alert(res.data.variable2 || res.data.variable3 || "Error al guardar.");
      }
    });
  };

  imprimir = async () => {
    const { idInforme, cedulaEspecialista } = this.props;
    const { tieneFirmaEsp } = this.state;
    if (!idInforme) {
      alert("Guarde el informe antes de imprimir.");
      return;
    }
    let tieneFirma = tieneFirmaEsp;
    if (!tieneFirma) {
      try {
        const est = await estadoFirmaEspecialista(cedulaEspecialista);
        tieneFirma = est.tiene;
        if (tieneFirma) this.setState({ tieneFirmaEsp: true });
      } catch (e) {
        tieneFirma = false;
      }
    }
    if (!tieneFirma) {
      alert(MSG_FIRMA_PDF_REQUERIDA);
      if (this.firmaRef.current && this.firmaRef.current.abrirSelector) {
        this.firmaRef.current.abrirSelector();
      }
      return;
    }
    const script = pdfEvalInicialScript(RAMA_SENSORIAL);
    const data = new FormData();
    data.append("idInforme", idInforme);
    axios({
      method: "post",
      url: API_INFORMES_PDF + script,
      responseType: "arraybuffer",
      data,
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob));
      })
      .catch(() => {
        window.open(API_INFORMES_PDF + script + "?idInforme=" + idInforme, "_blank");
      });
  };

  renderControl = (config, value, onChange) => {
    const tipo = config.tipo || TIPO_CAMPO.MULTILINEA;
    if (tipo === TIPO_CAMPO.FECHA) {
      return (
        <input
          type="date"
          className="ic-input ic-input-line"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    if (tipo === TIPO_CAMPO.MULTILINEA) {
      return (
        <textarea
          className="ic-textarea"
          rows={config.rows || 4}
          maxLength={config.maxLength || 2000}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    return (
      <input
        type="text"
        className="ic-input ic-input-line"
        maxLength={config.maxLength || 120}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  };

  renderCampoDg = (config) => {
    const dg = this.state.datos.datosGenerales;
    const val = config.key === "edadTexto" ? dg.edadTexto || dg.edad || "" : dg[config.key];
    return (
      <div className="ic-field" key={config.key}>
        <label className="ic-label">{config.label}</label>
        {this.renderControl(config, val, (v) => this.setDg(config.key, v))}
      </div>
    );
  };

  renderCampoRaiz = (config) => (
    <div className="ic-field" key={config.key}>
      <label className="ic-label">{config.label}</label>
      {this.renderControl(config, this.state.datos[config.key], (v) =>
        this.setField(config.key, v)
      )}
    </div>
  );

  renderCampoGrupo = (grupo, config) => (
    <div className="ic-field" key={config.key}>
      <label className="ic-label">{config.label}</label>
      {this.renderControl(config, this.state.datos[grupo][config.key], (v) =>
        this.setNested(grupo, config.key, v)
      )}
    </div>
  );

  renderSeccion = (titulo, children) => (
    <div className="ic-formSection">
      <h4>{titulo}</h4>
      {children}
    </div>
  );

  render() {
    const { guardando } = this.state;

    return (
      <div className="ic-panel ic-form-document">
        <p>
          Paciente:{" "}
          <strong>{this.props.nombrePaciente || this.props.cedulaPaciente}</strong>
        </p>
        <p className="ic-formato-badge">
          <strong>Evaluación Inicial — Integración Sensorial</strong>
        </p>
        <div className="ic-actions ic-actions-sticky">
          <button type="button" className="boton" onClick={this.props.onVolver}>
            Volver
          </button>
        </div>

        {this.renderSeccion(
          "Datos generales",
          <div className="ic-grid-datos">
            {CAMPOS_DATOS_GENERALES.map((c) => this.renderCampoDg(c))}
          </div>
        )}

        {this.renderSeccion(
          "Antecedentes",
          <div className="ic-grid-campos">
            {CAMPOS_ANTECEDENTES.map((c) => this.renderCampoGrupo("antecedentes", c))}
          </div>
        )}

        {this.renderSeccion(
          "Actividades de la vida diaria",
          <>
            <div className="ic-grid-campos">
              {CAMPOS_AVD.map((c) => this.renderCampoGrupo("avd", c))}
            </div>
            <div className="ic-grid-campos">
              {CAMPOS_AVD_INSTRUMENTALES.map((c) =>
                this.renderCampoGrupo("avdInstrumentales", c)
              )}
            </div>
          </>
        )}

        {this.renderSeccion(
          "Conducta",
          <div className="ic-grid-campos">
            {CAMPOS_CONDUCTA.map((c) => this.renderCampoGrupo("conducta", c))}
          </div>
        )}

        {this.renderSeccion(
          "Cognición",
          <div className="ic-grid-campos">
            {CAMPOS_COGNICION_BASE.map((c) => this.renderCampoGrupo("cognicion", c))}
            <p className="ic-hint">Sensorial</p>
            {CAMPOS_SENSORIAL_SISTEMAS.map((c) =>
              this.renderCampoGrupo("sistemasSensoriales", c)
            )}
            {CAMPOS_SOCIAL.map((c) => this.renderCampoGrupo("cognicion", c))}
          </div>
        )}

        {this.renderSeccion(
          "Motricidad fina",
          <div className="ic-grid-campos">
            {CAMPOS_MOTRICIDAD_FINA.map((c) => this.renderCampoGrupo("motricidadFina", c))}
          </div>
        )}

        {this.renderSeccion(
          "Motricidad gruesa",
          <div className="ic-grid-campos">
            {CAMPOS_MOTRICIDAD_GRUESA.map((c) =>
              this.renderCampoGrupo("motricidadGruesa", c)
            )}
          </div>
        )}

        {this.renderSeccion(
          "Observaciones",
          <div className="ic-grid-campos">
            {CAMPOS_OBSERVACIONES.map((c) => this.renderCampoRaiz(c))}
          </div>
        )}

        {this.renderSeccion(
          "Cierre",
          <div className="ic-grid-campos">
            {CAMPOS_CIERRE.map((c) => this.renderCampoRaiz(c))}
          </div>
        )}

        <FirmaEspecialistaInforme
          ref={this.firmaRef}
          cedulaEspecialista={this.props.cedulaEspecialista}
          onCambio={(tiene) => this.setState({ tieneFirmaEsp: tiene })}
        />

        <div className="ic-actions">
          <button type="button" className="boton" onClick={this.guardar} disabled={guardando}>
            {guardando ? "Guardando..." : "Guardar"}
          </button>
          <button type="button" className="boton" onClick={this.imprimir}>
            Imprimir PDF
          </button>
          {this.props.idInforme > 0 && this.props.onEliminar && (
            <button
              type="button"
              className="boton ic-btn-danger"
              onClick={() => this.props.onEliminar(this.props.idInforme)}
            >
              Eliminar informe
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default InformeEvaluacionInicialSensorial;
